function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTraining(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-17"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 416.78,
    y: 398.49,
    width: 33.12,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 322.53,
    y: 401.21,
    width: 8.69,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396.59,
    y: 389.21,
    width: 19.19,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.46,
    y: 390.89,
    width: 43.19,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104.56,
    y: 390.89,
    width: 6.33,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.47,
    y: 395.11,
    width: 93.68,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.4,337.8H45.3a5.71,5.71,0,0,1-5.71-5.71V60.66A5.71,5.71,0,0,1,45.3,55H238.4a5.71,5.71,0,0,1,5.71,5.71V332.09A5.71,5.71,0,0,1,238.4,337.8ZM45.3,55.2a5.47,5.47,0,0,0-5.46,5.46V332.09a5.47,5.47,0,0,0,5.46,5.46H238.4a5.47,5.47,0,0,0,5.46-5.46V60.66a5.47,5.47,0,0,0-5.46-5.46Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.7,337.8H261.6a5.71,5.71,0,0,1-5.71-5.71V60.66A5.71,5.71,0,0,1,261.6,55H454.7a5.71,5.71,0,0,1,5.71,5.71V332.09A5.71,5.71,0,0,1,454.7,337.8ZM261.6,55.2a5.47,5.47,0,0,0-5.46,5.46V332.09a5.47,5.47,0,0,0,5.46,5.46H454.7a5.47,5.47,0,0,0,5.46-5.46V60.66a5.47,5.47,0,0,0-5.46-5.46Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    y: 382.4,
    width: 500,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.85,352.83s-.67-34.22,9.4-55.36,19.46-38.58,25.83-45.62c0,0-18.79,47.64-21.47,61.39s-9.4,39.59-9.4,39.59Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.36,351.32s.84-36.74,8.05-50.83,18.79-36.06,18.79-36.06S428,296.64,425.1,310.22s-9.23,41.1-9.23,41.1Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.76,354.36s.67-34.22-9.39-55.36-19.46-38.58-25.84-45.63c0,0,18.79,47.64,21.48,61.4s9.39,39.59,9.39,39.59Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.25,352.85s-.84-36.74-8.05-50.83S379.41,266,379.41,266s13.25,32.2,16.11,45.79,9.22,41.1,9.22,41.1Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.66,353.59s9.73-32.82,5.64-55.87-8.51-42.36-12.79-50.85c0,0,5.46,50.92,4.4,64.9s-1.46,40.66-1.46,40.66Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.6,351.73s8.95-35.64,5.74-51.14-8.54-39.76-8.54-39.76,4.22,34.57,3.36,48.43-2,42.07-2,42.07Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410,355.19s-6.88-33.52-.83-56.14,12.11-41.48,17.1-49.56c0,0-9.81,50.26-9.94,64.27s-2,40.64-2,40.64Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.16,353.43s-5.86-36.27-1.33-51.44,11.92-38.88,11.92-38.88-7.18,34.08-7.51,48-1.59,42.09-1.59,42.09Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.52,383H404a7.85,7.85,0,0,1-7.84-7.38l-2-24.74h30.17l-2,24.74A7.86,7.86,0,0,1,414.52,383Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.75,323.32c.13.14-.56,1.1,2.23.68,6.87-1,18.83-3.82,22.16-10.89,4.76-10.09-10-6.41-9.48-11.56s17.29-4.26,19.07-11.83-9.6-4-9.75-7.65,13-1.4,15.56-9.56-7.3-2.16-6.16-5.55,12.23-18.75,6.19-20.53-16.2,14-20.13,16.2S115,252,110.36,257.44s2.74,24.42-3.23,28.11c-4.44,2.74-3.19-4.82-9-3.41C90.12,284.06,92.8,312.18,102.75,323.32Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124,282.11a23.81,23.81,0,0,0-5.94,1.22,45.89,45.89,0,0,1,4.22-5.43.51.51,0,0,0,0-.72.52.52,0,0,0-.72,0,59.4,59.4,0,0,0-8.46,12.27c-2.16-13,3.29-24.39,3.35-24.51a.38.38,0,0,0-.18-.51.38.38,0,0,0-.51.17c-.06.13-5.88,12.27-3.24,25.93-.7,1.34-1.41,2.77-2.11,4.31a96.34,96.34,0,0,0-5.8,17,35,35,0,0,1-4.06-15.54.38.38,0,0,0-.39-.37.37.37,0,0,0-.37.39,35.21,35.21,0,0,0,4.55,16.59A118.72,118.72,0,0,0,101.72,348a.51.51,0,0,0,.54.48h.06a.51.51,0,0,0,.41-.54c-1.26-18.29,1.48-33,5.26-44.13a14.05,14.05,0,0,1,8.13-4.64.41.41,0,0,0,.32-.43.38.38,0,0,0-.44-.32,14.34,14.34,0,0,0-7.41,3.68,84.79,84.79,0,0,1,8.68-17.64,20.8,20.8,0,0,1,6.75-1.59.38.38,0,1,0-.06-.76Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94,327.22c-5.71.11-15.46-5.2-19.29-10.35s7-2,5.92-6.1-14.59-1.07-17.08-7,7.23-4.53,6.85-7.54-10.46-2.4-13.69-8.66,5.63-2.75,4.24-5.34-12.5-13.51-7.85-15.78,15,9.09,18.54,10.36,4.3-6.59,8.84-2.83,1.14,20.17,6.48,22.34c4,1.61,2.29-5.91,6.87-4C101.8,295.67,96.27,327.17,94,327.22Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M94,327.22c-5.71.11-15.46-5.2-19.29-10.35s7-2,5.92-6.1-14.59-1.07-17.08-7,7.23-4.53,6.85-7.54-10.46-2.4-13.69-8.66,5.63-2.75,4.24-5.34-12.5-13.51-7.85-15.78,15,9.09,18.54,10.36,4.3-6.59,8.84-2.83,1.14,20.17,6.48,22.34c4,1.61,2.29-5.91,6.87-4C101.8,295.67,96.27,327.17,94,327.22Z",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M92.06,320.37a.44.44,0,0,0,.21-.17,30.1,30.1,0,0,0,2.56-15.3.4.4,0,0,0-.41-.36.38.38,0,0,0-.35.42,30.46,30.46,0,0,1-2.32,14.54,116,116,0,0,0-8.69-18.39c1-12.26-5.27-22.3-5.34-22.4a.37.37,0,0,0-.52-.12.39.39,0,0,0-.12.53,39.68,39.68,0,0,1,5.29,20.81,106.71,106.71,0,0,0-14.6-19.52.52.52,0,0,0-.72,0,.51.51,0,0,0,0,.72A99,99,0,0,1,78.2,295.23a29.72,29.72,0,0,0-10.79-1.9.38.38,0,0,0-.38.39.39.39,0,0,0,.38.37h0a29.23,29.23,0,0,1,11.51,2.24A123.23,123.23,0,0,1,85.15,307a12.94,12.94,0,0,0-10.65-1.87.38.38,0,0,0-.28.47.4.4,0,0,0,.47.27A12.31,12.31,0,0,1,86,308.6,103.33,103.33,0,0,1,97,350.45a.51.51,0,0,0,.51.49h0a.51.51,0,0,0,.49-.53A100.09,100.09,0,0,0,92.06,320.37Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110,383c5.45-10.24,9-25.05,9-31.54a18.11,18.11,0,0,0-6.65-13.85H84.47a18.11,18.11,0,0,0-6.65,13.85c0,6.49,3.58,21.3,9,31.54Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136.97,
    y: 58.18,
    width: 1.14,
    height: 33.91,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "101.31 110.93 137.54 89.03 173.77 110.93 101.31 110.93",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "140.04 110.93 137.54 89.03 153.83 110.93 140.04 110.93",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 361.89,
    y: 58.18,
    width: 1.14,
    height: 33.91,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "326.23 110.93 362.46 89.03 398.69 110.93 326.23 110.93",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "364.96 110.93 362.46 89.03 378.75 110.93 364.96 110.93",
    style: {
      fill: "#fafafa"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-17"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--path--inject-17",
    cx: 245.18,
    cy: 412.39,
    rx: 193.89,
    ry: 11.32,
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Board--inject-17"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M186.12,137.16a2.47,2.47,0,0,0-4.93,0l-.26,3.18h5.45Zm-2.47,1.66a1.21,1.21,0,1,1,1.21-1.2A1.2,1.2,0,0,1,183.65,138.82Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.56,137.16a2.48,2.48,0,0,0-4.94,0l-.26,3.18h5.46Zm-2.47,1.66a1.21,1.21,0,1,1,1.2-1.2A1.2,1.2,0,0,1,309.09,138.82Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 158.57,
    y: 139.84,
    width: 174.3,
    height: 108,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 158.57,
    y: 139.84,
    width: 174.3,
    height: 108,
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 163.03,
    y: 144.3,
    width: 165.38,
    height: 99.08,
    style: {
      fill: "#fff",
      opacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 156.52,
    y: 244.87,
    width: 178.41,
    height: 5.18,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 156.52,
    y: 244.87,
    width: 178.41,
    height: 5.18,
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 179.76,
    y: 162.13,
    width: 12.72,
    height: 16.71,
    style: {
      fill: "#263238",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.33,178.84a29.72,29.72,0,0,1-3-16.71H180a29.72,29.72,0,0,0,3,16.71Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.33,178.84a29.72,29.72,0,0,1-3-16.71H180a29.72,29.72,0,0,0,3,16.71Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 301.87,
    y: 162.13,
    width: 12.72,
    height: 16.71,
    style: {
      fill: "#263238",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.44,178.84a29.72,29.72,0,0,1-3-16.71H302.06a29.72,29.72,0,0,0,3,16.71Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.44,178.84a29.72,29.72,0,0,1-3-16.71H302.06a29.72,29.72,0,0,0,3,16.71Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 209.57,
    y: 162.42,
    width: 12.72,
    height: 16.71,
    style: {
      fill: "#263238",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.14,179.13a29.62,29.62,0,0,1-3-16.71H209.76a29.72,29.72,0,0,0,3,16.71Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.14,179.13a29.62,29.62,0,0,1-3-16.71H209.76a29.72,29.72,0,0,0,3,16.71Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 275.9,
    y: 162.13,
    width: 12.72,
    height: 16.71,
    style: {
      fill: "#263238",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.47,178.84a29.72,29.72,0,0,1-3-16.71H276.1a29.62,29.62,0,0,0,3,16.71Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.47,178.84a29.72,29.72,0,0,1-3-16.71H276.1a29.62,29.62,0,0,0,3,16.71Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.47,176.38c-1.28-7.74,3-14.93,10.72-17s17.07,2.41,17.84,11c1.41,15.85-23,19.83-26.8,4.85a.49.49,0,0,0-1,.26c1.91,7.57,8.31,10.57,15.86,10.11a14.1,14.1,0,0,0,12.83-16c-1.24-8.63-10.42-13.14-18.44-11.35-8.61,1.93-13.42,9.83-12,18.32.11.63,1.06.37,1-.26Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179,189.81a186.47,186.47,0,0,1,38.24-4.7c.67,0,.68-1.07,0-1.05a187.82,187.82,0,0,0-38.52,4.74c-.66.16-.38,1.17.28,1Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.27,191.59a113.62,113.62,0,0,1,22.87-2.81c.67,0,.68-1.07,0-1.05A114.78,114.78,0,0,0,188,190.58a.52.52,0,0,0,.27,1Z",
    style: {
      fill: "#407BFF"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-3--inject-17"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M376.73,174.71c-.1.48-.43.82-.75.75s-.49-.5-.39-1,.43-.82.75-.76S376.83,174.23,376.73,174.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.34,175.54a17.63,17.63,0,0,1-3.13,3.64,2.82,2.82,0,0,0,2.21.9Z",
    style: {
      fill: "#a02724"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379,172.39a.31.31,0,0,0,.2-.07.3.3,0,0,0,0-.41,2.87,2.87,0,0,0-2.46-.95.28.28,0,0,0-.23.33.27.27,0,0,0,.33.23h0a2.33,2.33,0,0,1,1.93.78A.3.3,0,0,0,379,172.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.43,181.47c-.87,4.46-1.74,12.61,1.37,15.58,0,0-1.21,4.52-9.49,4.52-9.09,0-4.34-4.52-4.34-4.52,5-1.18,4.83-4.86,4-8.32Z",
    style: {
      fill: "#b55b52"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393,177c-1.56,5.83-2.18,9.33-5.78,11.75-5.42,3.65-12.16-.54-12.37-6.72-.19-5.57,2.4-14.17,8.66-15.35A8.24,8.24,0,0,1,393,177Z",
    style: {
      fill: "#b55b52"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.55,179.37s1.3,8,9.17,7.75c0,0,9.51-5.35,8.52-15.45,0,0,3-3.95,1.2-5.59-1.17-1-2.54,1.2-2.54,1.2s.66-5.79-1.71-6.42-2.62,3.09-2.62,3.09-.55-5.86-3-6.17c-2.82-.36-2,3.79-2,3.79s-.92-4.88-3.68-4.87c-2.3,0-1.19,4.64-1.19,4.64s-2.18-4.93-4.27-3.8.59,4.75.59,4.75-4-2.81-4.8-.87,3.26,4.31,3.26,4.31-3.9.45-3.58,2.33,4.88,1.59,4.88,1.59S377,173.9,381,175.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.05,177.19a6.78,6.78,0,0,1-2.45,3.63c-1.58,1.18-2.77,0-2.66-1.77.11-1.61,1.05-4.17,2.8-4.65S383.51,175.44,383.05,177.19Z",
    style: {
      fill: "#b55b52"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.19,187.8c-1.41-.25-2.08.07-4.17-1.78a8.15,8.15,0,0,0,6.19,4C382.14,189.79,381.52,188,380.19,187.8Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.18,202.65c1.57,3.1,3,6.17,4.35,9.32s2.61,6.34,3.77,9.6c.6,1.62,1.12,3.28,1.64,5l.1.31,0,.16.07.27a7.79,7.79,0,0,1,.22,1.09,8.55,8.55,0,0,1,0,2.26,9.33,9.33,0,0,1-1.39,3.85,14.2,14.2,0,0,1-4.67,4.43,19.21,19.21,0,0,1-2.55,1.31,18.92,18.92,0,0,1-2.69,1l-1.89-4a33.35,33.35,0,0,0,3.29-3.09,9.14,9.14,0,0,0,2-3.07,1.46,1.46,0,0,0,.09-.93.89.89,0,0,0-.12-.26s-.05-.09-.07-.14l-.07-.17-.12-.28c-.59-1.51-1.23-3-1.87-4.53-1.3-3-2.67-6-4.06-9l-4.19-9Z",
    style: {
      fill: "#b55b52"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.27,236.62l-4.35-1.13-.25,7s3.41.5,5.49-1.58Z",
    style: {
      fill: "#b55b52"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "394.75 234.31 395.74 240.47 400.67 242.52 400.92 235.49 394.75 234.31",
    style: {
      fill: "#ffc3bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.26,199.67c-1.71,0-3.67,0-5.5-.14s-3.72-.21-5.57-.38-3.67-.38-5.44-.68c-.91-.12-1.77-.32-2.65-.47s-1.73-.38-2.55-.63l-1.23-.35-1.17-.41-.34-.11a3.87,3.87,0,0,1-.17-.69,14,14,0,0,1-.22-2.3c-.06-3.39.85-9.55,1.36-13.25l-3.83-.8a59.39,59.39,0,0,0-4.95,14.3,20.07,20.07,0,0,0-.27,3.57,11.53,11.53,0,0,0,.94,4.49c.4.87.62,1,1.58,1.79a7.82,7.82,0,0,0,1.56,1l.78.36c.52.23,1,.48,1.56.69l1.55.59a60.24,60.24,0,0,0,12.41,2.81c2.06.23,4.11.44,6.17.53s4.05.15,6.26.06Z",
    style: {
      fill: "#b55b52"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.69,180.64l3.26-6.88-6.39-1.85s-3,4.49-.39,8.1Z",
    style: {
      fill: "#b55b52"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "347.56 170.66 342.6 168.11 341.56 171.91 347.95 173.76 347.56 170.66",
    style: {
      fill: "#b55b52"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.38,197.52a2.73,2.73,0,0,0,.41-3.21s21.1-1.75,15.6,3.83Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.38,197.52a2.73,2.73,0,0,0,.41-3.21s21.1-1.75,15.6,3.83Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401,223.23s7.28-3.1,12-8.93c0,0-4.54-14.49-9.71-15.44S401,223.23,401,223.23Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401,223.23s7.28-3.1,12-8.93c0,0-4.54-14.49-9.71-15.44S401,223.23,401,223.23Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.15,209.15a137.69,137.69,0,0,0,.81,14.08,34,34,0,0,0,3.66-1.93A63.19,63.19,0,0,0,400.15,209.15Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.6,199.47c-4.12,20.08-3.54,38.13-3,49a6.82,6.82,0,0,1-5.75,7.1,83.92,83.92,0,0,1-23-.37,6.82,6.82,0,0,1-5.69-5.72c-4.78-30.77-2.34-43.06-.77-49.05a4.72,4.72,0,0,1,4.57-3.51C379.45,196.86,401.25,197.06,404.6,199.47Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.6,199.47c-4.12,20.08-3.54,38.13-3,49a6.82,6.82,0,0,1-5.75,7.1,83.92,83.92,0,0,1-23-.37,6.82,6.82,0,0,1-5.69-5.72c-4.78-30.77-2.34-43.06-.77-49.05a4.72,4.72,0,0,1,4.57-3.51C379.45,196.86,401.25,197.06,404.6,199.47Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.72,203.66a83.35,83.35,0,0,0-1.33,17.85c6.2-2.79,7.69-12.36,7.69-12.36l-2.79-6.34Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.69,196.9c-2.83-1.58-15.9,2-15.9,2v14.78s13.1,3.31,15.85-1.2S374.15,198.83,370.69,196.9Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.69,196.9c-2.83-1.58-15.9,2-15.9,2v14.78s13.1,3.31,15.85-1.2S374.15,198.83,370.69,196.9Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "383.98 406.15 377.89 406.15 377.29 392.05 383.37 392.05 383.98 406.15",
    style: {
      fill: "#b55b52"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "428.65 403.33 422.7 404.62 416.73 391.49 422.68 390.2 428.65 403.33",
    style: {
      fill: "#b55b52"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "377.29 392.06 377.6 399.32 383.69 399.32 383.38 392.06 377.29 392.06",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "422.68 390.2 416.73 391.49 419.81 398.26 425.76 396.97 422.68 390.2",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.62,251.34s8.81,58.49,12.6,75.91c4.16,19.08,24.52,70.23,24.52,70.23l10.89-2.35s-5.85-17-11.7-42.69c-1.95-8.57-5.58-16.79-6.45-23.46-1.46-11.17-3.29-41.65-4.75-56.18a122.75,122.75,0,0,0-4.1-21.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.13,393.85c-.05,0,2,3.94,2,3.94l12.26-2.66-1-3.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384,267.92c8,1.56,9,43.32,8.08,58.63-2.3-10.82-7.58-43.63-9.88-58.42A2.72,2.72,0,0,1,384,267.92Z",
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.08,251.34s1.06,57.48,1.72,76c.69,19.3,5.53,70.53,5.53,70.53h10.31a276.75,276.75,0,0,0,3.34-41.6c.12-11.24-1.74-21.49-1.6-27.46.25-10.15,1-38.11,2.69-51.75a193.88,193.88,0,0,0,1.4-25.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.35,393.81c-.05,0,.58,4.28.58,4.28h12.54l.34-3.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.05,403.77h7a.53.53,0,0,1,.53.52L386.8,411a1.32,1.32,0,0,1-1.06,1.28.85.85,0,0,1-.23,0c-2.89-.1-5.43-.31-9-.36-4.26-.07-3.28.45-8.3.44-3,0-2.91-3.46-1.6-3.61,6-.64,6.95-2.4,9.62-4.46A3.06,3.06,0,0,1,378.05,403.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.57,401.81l6.84-1.48a.52.52,0,0,1,.63.39l2.61,6.33a1.33,1.33,0,0,1-.76,1.47.94.94,0,0,1-.22.07c-2.85.51-5.38.85-8.92,1.55-4.18.83-3.11,1.14-8,2.18-3,.63-3.57-2.77-2.32-3.19,5.73-1.88,6.29-3.8,8.46-6.38A3,3,0,0,1,421.57,401.81Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-2--inject-17"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M288.9,227.8l4.08-4.68a33.21,33.21,0,0,1,1.18-4.09c.48-1,1.51-3.27,2.56-3.63a5.9,5.9,0,0,1,4.6,1.36c1,1.19,1.5,4.81.8,6.22s-5.79,3.31-5.79,3.31l-4,5Z",
    style: {
      fill: "#ffb573"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "288.02 227.52 291.59 223.63 296.36 227.7 292.49 232.26 288.02 227.52",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "288.02 227.52 291.59 223.63 296.36 227.7 292.49 232.26 288.02 227.52",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.47,204.71s3.72,4.24,9.09,18.08,11.34,9.81,17.88,2.34l5.37,4.9s-10.05,12.52-16.37,12.52c-7,0-13.88-10.92-15.25-18.54S262.47,204.71,262.47,204.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.78,212.72l-2-1.67-.93,5.33c.13,1.54.31,3.05.56,4.42.78,4.35,3.73,10,6.89,14.79A175.26,175.26,0,0,0,263.78,212.72Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.31,172.26s-2.84,0-2.46,2.19c.47,2.82,10.09,2,10.09,2l-2.56-3.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "274.99 391.2 275.96 404.31 270.14 404.31 267.28 391.67 274.99 391.2",
    style: {
      fill: "#ffb573"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.52,403.6h-7.15a.53.53,0,0,0-.55.52L267.58,411a1.35,1.35,0,0,0,1.08,1.3l.23,0c2.95-.11,5.55-.31,9.23-.37,4.35-.07,3.35.47,8.47.45,3.09,0,3-3.53,1.63-3.68-6.12-.65-7.09-2.45-9.81-4.56A3,3,0,0,0,276.52,403.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.16,401.53,268,402s-9.22-32.81-10.93-52.75c-.12-1.37-.2-2.69-.25-3.94a96.78,96.78,0,0,0-2-17.31l-.43-2-5-23.49h0l-1-4.48s-5.71-9.56-5.5-24.1a55.66,55.66,0,0,1,1.49-12,1.59,1.59,0,0,0,.08-.33l22,.64.84,10.86Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.57,312.8c3-15.26,1.52-33.36,1.52-33.36l-4.5,1.8-3,8.42s0,.68,0,1.8a36.05,36.05,0,0,0,2.81,6.55Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "233.16 391.2 231.25 404.31 225.43 404.31 225.46 391.67 233.16 391.2",
    style: {
      fill: "#ffb573"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.74,403.6h-7.15a.52.52,0,0,0-.54.52L222.8,411a1.35,1.35,0,0,0,1.08,1.3l.24,0c2.95-.11,5.54-.31,9.23-.37,4.34-.07,3.34.47,8.47.45,3.08,0,3-3.53,1.63-3.68-6.12-.65-7.09-2.45-9.81-4.56A3.06,3.06,0,0,0,231.74,403.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.86,262.25l-1.68,8-6.82,32.28-1.11,5.3-15.19,94-9.12-.4s-2-30.29.73-50.46c.21-1.59.47-3.12.75-4.56a103.06,103.06,0,0,0,2-20.42l0-2L227.07,298a115.38,115.38,0,0,1,1-26.21,72.18,72.18,0,0,1,2.36-10.19l14,.33Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.76,280.06l-8.1.71a4.34,4.34,0,0,1-5.05-3.11l-.26-1-1.7-6.28-2,7.27a4.58,4.58,0,0,1-5.07,3.33l-4.48-.64-13.86-1.92a75.75,75.75,0,0,1,3.21-16.85l14,.33a1.59,1.59,0,0,0,.08-.33l22,.64Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.89,245.93l-3.77,28.83,19.59,3a4.32,4.32,0,0,0,4.78-3.13l1.9-6.86,1.85,6.83a4.08,4.08,0,0,0,4.75,2.93l9.52-1.64-2.5-33.4s1.43-21.39-1.91-35.08a7.34,7.34,0,0,0-5.63-5,56.06,56.06,0,0,0-33.19,2.51,3.2,3.2,0,0,0-2,3.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 251.01,
    cy: 233.71,
    r: 0.88,
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 251.87,
    cy: 245.93,
    r: 0.88,
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 252.23,
    cy: 258,
    r: 0.88,
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.69,200.57a18.7,18.7,0,0,1,10.57-.74l2.16,1.24.77,2.41-2.75,2.16-6.48.66-5.36-2.22.29-2.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.16,201.81a7.15,7.15,0,0,0,1.59-6.13l9.71-7.87c-1.37,13.12-.7,10.74,1.25,14.51,0,0-1.35,4.38-8.93,3C235.87,204.45,237.16,201.81,237.16,201.81Z",
    style: {
      fill: "#ffb573"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.75,195.68l9.71-7.87c-.25,1.91-.45,3.49-.58,4.87a10.34,10.34,0,0,1-9.16,6A6.53,6.53,0,0,0,238.75,195.68Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.09,181.61c-1.37,6.27-1.86,10-5.56,12.75-5.57,4.14-12.93,0-13.45-6.53-.47-5.93,1.86-15.16,8.44-16.71a8.76,8.76,0,0,1,10.57,10.49Z",
    style: {
      fill: "#ffb573"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.9,181.89c-.08.52-.42.9-.75.84s-.55-.51-.46-1,.41-.89.75-.83S240,181.38,239.9,181.89Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.08,181c-.08.51-.42.88-.75.83s-.55-.51-.46-1,.41-.9.75-.84S234.16,180.47,234.08,181Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.21,181.52a18.29,18.29,0,0,1-3.15,4,3,3,0,0,0,2.39.85Z",
    style: {
      fill: "#ed893e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.28,179.79a.43.43,0,0,0,.16,0,.33.33,0,0,0,.12-.42,3.08,3.08,0,0,0-2.27-1.63.3.3,0,0,0-.33.28.31.31,0,0,0,.28.34h0a2.41,2.41,0,0,1,1.78,1.31A.33.33,0,0,0,242.28,179.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.18,178.28a.26.26,0,0,0,.26-.13,2.43,2.43,0,0,1,1.9-1.1.32.32,0,0,0,.32-.3.3.3,0,0,0-.3-.31,3,3,0,0,0-2.44,1.37.28.28,0,0,0,.07.41h0A.27.27,0,0,0,232.18,178.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.46,188.46a37.13,37.13,0,0,1,6.24-.17c-.6,1.23-1.67,2.22-4,2.14S233.46,188.46,233.46,188.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.83,189.48a4.65,4.65,0,0,0-2.59.53,2.62,2.62,0,0,0,1.44.41,4.65,4.65,0,0,0,2.59-.53A2.54,2.54,0,0,0,236.83,189.48Z",
    style: {
      fill: "#ff5652"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.68,188.43a.86.86,0,0,0,.68.64,27.68,27.68,0,0,0,4.07-.2,1.36,1.36,0,0,0,1.07-.58A41.87,41.87,0,0,0,233.68,188.43Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "237.14 208.74 239.72 217.15 245.72 225.81 250.64 230.93 252.48 223.43 251.89 207.77 251.79 204.4 250.42 202.46 248.23 204.38 246.37 205.09 243.64 205.12 236.47 202.94 237.14 208.74",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "237.14 208.74 239.72 217.15 245.72 225.81 250.64 230.93 252.48 223.43 251.89 207.77 251.79 204.4 250.42 202.46 248.23 204.38 246.37 205.09 243.64 205.12 236.47 202.94 237.14 208.74",
    style: {
      fill: "#407BFF",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "237.14 208.74 239.72 217.15 245.72 225.81 250.64 230.93 252.48 223.43 251.89 207.77 251.79 204.4 250.42 202.46 248.23 204.38 246.37 205.09 243.64 205.12 236.47 202.94 237.14 208.74",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.93,207.77a11.46,11.46,0,0,0,2.79,3.57s-1.2,8.56.64,14.56l4.28,5,1.25-6.22s-1.91-10-4.48-13.72a15.7,15.7,0,0,0,1.42-4.1l-1.53-1.25s-2.13,1.52-3.41.46Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237,201.34s4,3.37,7.93,3.37,4.41-4.14,4.41-4.14l1.68,1.81a11.88,11.88,0,0,1-1.37,6l-4.14-2.8-2.81,4a16.88,16.88,0,0,1-6.55-5.91Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237,201.34s4,3.37,7.93,3.37,4.41-4.14,4.41-4.14l1.68,1.81a11.88,11.88,0,0,1-1.37,6l-4.14-2.8-2.81,4a16.88,16.88,0,0,1-6.55-5.91Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.69,200.57s-3.24,10,12.73,29.07c0,0,2.86-23.37-2.16-29.81l3.49,1.38,3.64,5.5-2.67,1.71,3.3,1.47s-.47,7.57-5.11,22.14c0,0-10.5-8.12-17.36-19.08l3.19-2.55-4.27-.67,1.9-7.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.69,200.57s-3.24,10,12.73,29.07c0,0,2.86-23.37-2.16-29.81l3.49,1.38,3.64,5.5-2.67,1.71,3.3,1.47s-.47,7.57-5.11,22.14c0,0-10.5-8.12-17.36-19.08l3.19-2.55-4.27-.67,1.9-7.59Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247,187s-2.56,1.32-.87-3.66-.57-6.59-.88-9c0,0-14.56.5-13.87-5.93s9.43-1.32,9.43-1.32-.66-2.92,1.78-3.25c3.27-.43,6.25,5.88,10.3,7.75s1.8,8.16,1.8,8.16,1.24,4.19-6.17,12.2a.46.46,0,0,1-.79-.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.74,181c-.16-.11-.83-.44-1.21-.62a5.47,5.47,0,0,0-2.73-.85,2.76,2.76,0,0,0-2,.42.71.71,0,0,0-.11.17.75.75,0,0,0-.4-.17,1,1,0,0,0-.45.06.92.92,0,0,0-.09-.23,4.74,4.74,0,0,0-3-1.1,2.83,2.83,0,0,0-2,.42,1,1,0,0,0-.22.73,4.6,4.6,0,0,0,1.08,2.66,3.82,3.82,0,0,0,2.25.65,2.12,2.12,0,0,0,1-.2,3.39,3.39,0,0,0,1.07-2,2.2,2.2,0,0,0,0-.44.58.58,0,0,1,.28-.06.8.8,0,0,1,.35.26,4.58,4.58,0,0,0,1.09,2.64,3.79,3.79,0,0,0,2.24.65,2.06,2.06,0,0,0,1-.2h0a3.42,3.42,0,0,0,1.07-2,2.26,2.26,0,0,0,0-.63,3.41,3.41,0,0,1,.46.26,66.4,66.4,0,0,1,5,4.9l.36-.34A62.63,62.63,0,0,0,242.74,181Zm-7.1-.11a3.07,3.07,0,0,1-.93,1.79,3.55,3.55,0,0,1-2.88-.41,4.35,4.35,0,0,1-1-2.45.65.65,0,0,1,.13-.5,2.13,2.13,0,0,1,1.4-.35h.37a4.43,4.43,0,0,1,2.78,1A1.22,1.22,0,0,1,235.64,180.88Zm6,.84a3.17,3.17,0,0,1-.94,1.8,3.56,3.56,0,0,1-2.87-.41,4.38,4.38,0,0,1-1-2.45.7.7,0,0,1,.13-.51,2.23,2.23,0,0,1,1.41-.34h.37a4.36,4.36,0,0,1,2.77,1A1.19,1.19,0,0,1,241.68,181.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.26,188a6.11,6.11,0,0,1-4.17,2.07c-2.13.13-2.76-1.88-1.79-3.67.87-1.59,3-3.59,5-2.89A2.73,2.73,0,0,1,252.26,188Z",
    style: {
      fill: "#ffb573"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.72,211l4.15,23.17.49-.61a57.11,57.11,0,0,0-.9-23.25l-1.26.67Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.45,228.6l-4.84-3.89a33.86,33.86,0,0,0-1.88-3.83c-.65-.9-2.06-2.94-3.16-3.12a5.94,5.94,0,0,0-4.29,2.14c-.79,1.35-.63,5,.3,6.27s6.29,2.24,6.29,2.24l4.77,4.18Z",
    style: {
      fill: "#ffb573"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "198.26 228.17 194.07 224.97 190.09 229.8 194.69 233.62 198.26 228.17",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "198.26 228.17 194.07 224.97 190.09 229.8 194.69 233.62 198.26 228.17",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.43,205.86c-.38-.45-1.71.15-2.05.63-1.11,1.58-7.35,16.83-9.8,22.87a3,3,0,0,1-3.57,1.75,70.6,70.6,0,0,1-12.21-4.51l-5.37,4.9s14,11.16,21.68,11.16c7,0,13.63-14.92,15-22.54A17,17,0,0,0,224.43,205.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.93,207.68l-24.17-2.27s-6.42,10.06-9.15,33l24.26,2.27C320.32,220.68,325.68,210.07,326.93,207.68Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.93,207.68l-24.17-2.27s-6.42,10.06-9.15,33l24.26,2.27C320.32,220.68,325.68,210.07,326.93,207.68Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.93,207.68l-24.17-2.27s-5.54,9.18-8.27,32.07l24.25,2.28C321.19,219.81,325.68,210.07,326.93,207.68Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.93,207.68l-24.17-2.27s-5.54,9.18-8.27,32.07l24.25,2.28C321.19,219.81,325.68,210.07,326.93,207.68Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.94,205.62a1.16,1.16,0,0,0-1.63-.3L301.94,207a1.17,1.17,0,1,0,1.34,1.93.19.19,0,0,0,.05-.27.2.2,0,0,0-.28-.05.78.78,0,0,1-1.09-.2.8.8,0,0,1,.2-1.09l2.37-1.64a.79.79,0,0,1,1.09.2.78.78,0,0,1-.2,1.09l-.8.55-.45.32-.1.07a.46.46,0,0,1-.62-.11.45.45,0,0,1,.11-.62l1.09-.76a.18.18,0,0,0,.05-.27.19.19,0,0,0-.27-.05l-1.09.76a.83.83,0,0,0-.22,1.16.84.84,0,0,0,1.16.21l.1-.07.46-.31.8-.56A1.16,1.16,0,0,0,305.94,205.62Z",
    style: {
      fill: "#407BFF"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-1--inject-17"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M97.18,189.37s2.83-1.88,1.47-7.48c0,0,4.43-1.18,5.16-4.45,0,0,.8,2.83,2.39,2.52s0-3.05,0-3.05,2.53,2.52,3.81,2.3,0-2.3,0-2.3,1.12,2.42,2.51,2c1.83-.53-1.86-4.35-1.86-4.35s2.66,4.2,3.42,3.19-4.72-6.95-12-6c0,0-8.92-1.33-11.3,7.69,0,0-6.9,4.3-3.45,10.86,0,0-5.66,6.53-2.21,9.95,0,0-5.67,9.68,1.15,9.48s26.58-1.37,29.34-3.28-.87-6.47-.87-6.47,1.23-1.35.92-4.54a6.53,6.53,0,0,0-2.06-4.51,3.7,3.7,0,0,0,1-4.45c-2.86-6.57-14.06-7-14.06-7S101.51,190.35,97.18,189.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.14,210.47a43.35,43.35,0,0,0,1-5.55l1.4-3.27s2.15-3.86,1.53-5c-.74-1.39-4.56-2.44-6-1.85-1.29.52-2.7,4.87-2.7,4.87l.86,4.43a32,32,0,0,1-1,4.78Z",
    style: {
      fill: "#ce7a63"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151,209c-1.88,7.94-5.49,19.55-19.65,15.2C124,222,113,215.94,116.12,208.51s4.33,3.92,16.73,7.91c9.38,3,10.33-3.69,12-9.37Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.69,201.34a16.67,16.67,0,0,1,9,.54s1.73,4.19-2,4.37-7-3.59-7-3.59Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.8,203.76s2.39-.09,2.37-3a60.76,60.76,0,0,0-.51-6.53l7.07.63s-.94,8.7,2.3,9.14C109,204,106.2,208.29,97.8,203.76Z",
    style: {
      fill: "#ce7a63"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.73,194.82l-7.07-.63s.18,1.32.32,3a10.41,10.41,0,0,0,6.93,3.84A24.48,24.48,0,0,1,106.73,194.82Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.13,184.7c.94,6.34,1.2,9,4.7,12,5.26,4.51,12.84,2,13.82-4.52.87-5.85-.81-15.23-7.26-17.23a8.74,8.74,0,0,0-11,5.71A8.64,8.64,0,0,0,95.13,184.7Z",
    style: {
      fill: "#ce7a63"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.32,186.17a14,14,0,0,0,2.13,3.15,2.2,2.2,0,0,1-1.81.51Z",
    style: {
      fill: "#ba4d3c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.35,183.28a.33.33,0,0,1-.12-.05.25.25,0,0,1,0-.36h0a3,3,0,0,1,2.45-1.23.25.25,0,0,1,.23.27.26.26,0,0,1-.27.24,2.47,2.47,0,0,0-2,1A.26.26,0,0,1,102.35,183.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.36,182.42l-.13,0A2.48,2.48,0,0,0,111,182a.25.25,0,0,1-.33-.14h0a.27.27,0,0,1,.15-.34,3,3,0,0,1,2.7.45.27.27,0,0,1,.08.36.28.28,0,0,1-.25.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.58,185.62c0,.52.36.92.7.89s.58-.47.53-1-.36-.92-.69-.89S105.54,185.1,105.58,185.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.45,185.12c0,.52.36.91.69.88s.58-.47.54-1-.36-.91-.7-.88S111.4,184.6,111.45,185.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.84,184.17l1.21-.46S112.49,184.73,111.84,184.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106,184.67l1.22-.46S106.63,185.23,106,184.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.41,192.86a5.26,5.26,0,0,0,.89-.08.15.15,0,0,0,.13-.18h0a.15.15,0,0,0-.18-.13,4.23,4.23,0,0,1-3.68-1,.15.15,0,0,0-.22,0,.16.16,0,0,0,0,.22A4.42,4.42,0,0,0,108.41,192.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127,307c-.09,24.68-3.87,98.91-3.87,98.91h-7s-4.13-30.15-3.7-56.66c.16-9.59,1-16.92,1.09-22.61.16-10.26-7.68-45.42-7.68-45.42l21.26,2.6S127,301.14,127,307Z",
    style: {
      fill: "#ce7a63"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.67,323.52c.14-4.66.24-8.88.3-12.47l-15.38-.7a132.75,132.75,0,0,1,1.89,14.83A29.22,29.22,0,0,0,126.67,323.52Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.7,404h-6.82a.5.5,0,0,0-.51.51l-1.07,6.55a1.33,1.33,0,0,0,1,1.25l.22,0c2.81-.1,5.29-.3,8.8-.35,4.14-.07,3.2.44,8.08.43,3,0,2.78-3.37,1.5-3.51-5.85-.62-6.8-2.34-9.43-4.35A3,3,0,0,0,122.7,404Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.32,308.78,90,406.2H83.11s-2.32-28.38-.57-52.73c.65-9.06,2.46-17.08,3.42-22.72,2-11.79,1.64-49.91,1.64-49.91l18.37,3Z",
    style: {
      fill: "#ce7a63"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.21,324.82l2.31-20.91-15.8-.72c-.18,7-.49,13.86-1,18.6A136.22,136.22,0,0,0,101.21,324.82Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.76,404H82.94a.52.52,0,0,0-.52.51l-1.19,6.55a1.3,1.3,0,0,0,1,1.25l.23,0c2.81-.1,5.29-.3,8.8-.35,4.15-.07,3.19.44,8.08.43,2.94,0,2.83-3.37,1.55-3.51-5.83-.62-6.76-2.34-9.35-4.35A3,3,0,0,0,89.76,404Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "96.67 203.29 98.65 202.66 103.81 206.25 105.7 206.25 107.29 205.55 109.14 203.7 110.98 204.46 112.3 209.53 112.3 211.07 112.86 212.94 114.48 219.22 115.71 227.32 115.71 233.42 115.25 239.97 113.53 236.56 108.66 227.46 104.61 215.99 103.42 211.99 100.33 208.73 97.92 204.61 96.67 203.29",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "96.67 203.29 98.65 202.66 103.81 206.25 105.7 206.25 107.29 205.55 109.14 203.7 110.98 204.46 112.3 209.53 112.3 211.07 112.86 212.94 114.48 219.22 115.71 227.32 115.71 233.42 115.25 239.97 113.53 236.56 108.66 227.46 104.61 215.99 103.42 211.99 100.33 208.73 97.92 204.61 96.67 203.29",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "96.67 203.29 98.65 202.66 103.81 206.25 105.7 206.25 107.29 205.55 109.14 203.7 110.98 204.46 112.3 209.53 112.3 211.07 112.86 212.94 114.48 219.22 115.71 227.32 115.71 233.42 115.25 239.97 113.53 236.56 108.66 227.46 104.61 215.99 103.42 211.99 100.33 208.73 97.92 204.61 96.67 203.29",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.51,256.62s-5.07,13.92-5.3,22.43c-.21,8.1.66,17.52.53,25.11a94.72,94.72,0,0,1-1.29,14.24s27.39,8.71,45.18,1.06a265.66,265.66,0,0,0-4.19-62.84l-12.58.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.79,208.34,94,240.74a234.93,234.93,0,0,0-6.83,23.18s19,6.32,24.57,3.55c1.78-.89,3.83-7,3.83-7s3.19,6.43,5.32,7c1.75.43,6.55-3,6.55-3s-2.24-14.53-5-24.45l1.34-11s2.6-6.11-2.4-17l-1.44-4.39a2.36,2.36,0,0,0-1.14-1.36,35.86,35.86,0,0,0-9.16-3.23s7,16.58,5.32,32.83c0,0-6.82-24.09-17.73-33.28a20.41,20.41,0,0,0-7.78,2.42A3.22,3.22,0,0,0,87.79,208.34Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.18,202.66l1.51-1.32s4.1,4.48,6.83,4.33,2.18-3.79,2.18-3.79l1.89,1.23.84.78-.2,4.84s-2.39-2.8-3.8-2.39-2.62,3.42-2.62,3.42S100.64,208,97.18,202.66Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.18,202.66l1.51-1.32s4.1,4.48,6.83,4.33,2.18-3.79,2.18-3.79l1.89,1.23.84.78-.2,4.84s-2.39-2.8-3.8-2.39-2.62,3.42-2.62,3.42S100.64,208,97.18,202.66Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.39,240.83s1.41-8.46,1.14-27.12l-3.67-2,2.3-.64a64,64,0,0,0-4-7.58c-.52-.13-1-.26-1.59-.38,0,0,7,19.45,5.32,35.7,0,0-6.82-27-17.73-36.15,0,0-.51,0-1.33.18A15,15,0,0,1,100,212.9h2.93l-2.39,2.18Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.39,240.83s2.47-7.4,2.2-26.05l-4.73-3.07,3.37-.64-5-7.58c-.52-.13-1-.26-1.59-.38,0,0,7,19.45,5.32,35.7,0,0-6.82-27-17.73-36.15,0,0-.51,0-1.33.18,1.38,1.45,1.94,4.93,2,10.06h5.05l-3.45,4.3Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.88,253.72l15.52-.4a1.23,1.23,0,0,0,1.16-1.1l1.88-23.87a1,1,0,0,0-1-1l-15.52.4a1.23,1.23,0,0,0-1.16,1.11l-1.89,23.86A1,1,0,0,0,109.88,253.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.69,229.44l3.72-.09a1.52,1.52,0,0,0,1.44-1.38l.18-2.2-6.4.17-.17,2.2A1.17,1.17,0,0,0,117.69,229.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.69,229.44l3.72-.09a1.52,1.52,0,0,0,1.44-1.38l.18-2.2-6.4.17-.17,2.2A1.17,1.17,0,0,0,117.69,229.44Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.23,227.8l.73,0a1.22,1.22,0,0,0-1.16,1.1l-1.89,23.87a1,1,0,0,0,1,1.05h-.73a1,1,0,0,1-1-1l1.89-23.87A1.22,1.22,0,0,1,111.23,227.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.23,227.8l.73,0a1.22,1.22,0,0,0-1.16,1.1l-1.89,23.87a1,1,0,0,0,1,1.05h-.73a1,1,0,0,1-1-1l1.89-23.87A1.22,1.22,0,0,1,111.23,227.8Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.89,247.26a41.52,41.52,0,0,0,5.58-.71l3.54.39s4.33.93,5.26,0c1.11-1.12,1-5.08,0-6.31-.88-1.08-5.45-1.16-5.45-1.16l-4,2.12a32.65,32.65,0,0,1-4.87.4Z",
    style: {
      fill: "#ce7a63"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.46,247.71c-8.14.52-23.37-.7-23.35-15.51,0-7.63,3.81-28.22,11.83-27.4s-3.53,9.14-3.53,26.35c0,9.85,9.2,10.2,15.12,10.14Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.46,247.71c-8.14.52-23.37-.7-23.35-15.51,0-7.63,3.81-28.22,11.83-27.4s-3.53,9.14-3.53,26.35c0,9.85,9.2,10.2,15.12,10.14Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.18,189.37s2.83-1.88,1.47-7.48c0,0,4.43-1.18,5.16-4.45,0,0,.8,2.83,2.39,2.52s0-3.05,0-3.05,2.53,2.52,3.81,2.3,0-2.3,0-2.3,1.13,2.45,2.51,2-.58-2.67-.58-2.67,1.79,2.54,2.19,1.33-4.77-6.77-12-5.8c0,0-8.92-1.33-11.3,7.69,0,0-3.8,2.48-1.92,8.38C88.91,187.85,98.07,189.57,97.18,189.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.05,189.87a4.68,4.68,0,0,0,2.49,2.57c1.51.64,2.48-.66,2.23-2.2-.22-1.38-1.27-3.38-2.87-3.37a2.11,2.11,0,0,0-2,2.19A2.28,2.28,0,0,0,94.05,189.87Z",
    style: {
      fill: "#ce7a63"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubbles--inject-17"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M380.27,134.46c0-8.09-8-14.66-17.81-14.66s-17.81,6.57-17.81,14.66,8,14.66,17.81,14.66a21,21,0,0,0,2.89-.2l7.27,3.77-.72-5.8C376.93,144.3,380.27,139.7,380.27,134.46Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.27,134.46c0-8.09-8-14.66-17.81-14.66s-17.81,6.57-17.81,14.66,8,14.66,17.81,14.66a21,21,0,0,0,2.89-.2l7.27,3.77-.72-5.8C376.93,144.3,380.27,139.7,380.27,134.46Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.16,135.24a5.41,5.41,0,0,0-5.5-5.4,5.64,5.64,0,0,0-5.31,5.24,5.42,5.42,0,0,0,2.06,4.41,3.61,3.61,0,0,1,1.38,2.28l0,.13a1.31,1.31,0,0,0,1.3,1.12h1.28a1.33,1.33,0,0,0,1.31-1.12l0-.13a3.52,3.52,0,0,1,1.33-2.26A5.37,5.37,0,0,0,368.16,135.24Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.05,145.31h-.6a1.45,1.45,0,0,1-1.44-1.45h0a.46.46,0,0,1,.46-.46H364a.47.47,0,0,1,.46.46h0A1.46,1.46,0,0,1,363.05,145.31Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.05,145.31h-.6a1.45,1.45,0,0,1-1.44-1.45h0a.46.46,0,0,1,.46-.46H364a.47.47,0,0,1,.46.46h0A1.46,1.46,0,0,1,363.05,145.31Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "364.29 139.59 363.73 139.44 364.45 136.82 363.76 137.22 363.69 136.4 362.75 137.1 361.81 136.4 361.74 137.22 361.06 136.82 361.77 139.44 361.21 139.59 360.12 135.58 361.24 136.25 361.31 135.32 362.75 136.38 364.19 135.32 364.26 136.25 365.38 135.58 364.29 139.59",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "364.29 139.59 363.73 139.44 364.45 136.82 363.76 137.22 363.69 136.4 362.75 137.1 361.81 136.4 361.74 137.22 361.06 136.82 361.77 139.44 361.21 139.59 360.12 135.58 361.24 136.25 361.31 135.32 362.75 136.38 364.19 135.32 364.26 136.25 365.38 135.58 364.29 139.59",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 362.42,
    y: 124.12,
    width: 0.66,
    height: 4.54,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 369.56,
    y: 135.14,
    width: 4.54,
    height: 0.66,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 351.4,
    y: 135.14,
    width: 4.54,
    height: 0.66,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 366.9,
    y: 128.72,
    width: 4.54,
    height: 0.66,
    transform: "translate(16.88 298.84) rotate(-45)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 354.06,
    y: 141.56,
    width: 4.54,
    height: 0.66,
    transform: "translate(4.04 293.52) rotate(-45)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 368.84,
    y: 139.62,
    width: 0.66,
    height: 4.54,
    transform: "translate(7.8 302.62) rotate(-45)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 356,
    y: 126.78,
    width: 0.66,
    height: 4.54,
    transform: "translate(13.12 289.77) rotate(-45)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.3,141.65c0-10.56,10.4-19.12,23.23-19.12s23.22,8.56,23.22,19.12-10.4,19.11-23.22,19.11a29.11,29.11,0,0,1-3.77-.25l-7.47,4.9-1.07-7.55C103.66,154.48,99.3,148.48,99.3,141.65Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.3,141.65c0-10.56,10.4-19.12,23.23-19.12s23.22,8.56,23.22,19.12-10.4,19.11-23.22,19.11a29.11,29.11,0,0,1-3.77-.25l-7.47,4.9-1.07-7.55C103.66,154.48,99.3,148.48,99.3,141.65Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.1,142.67a7.05,7.05,0,0,1,7.16-7,7.38,7.38,0,0,1,6.94,6.84,7.05,7.05,0,0,1-2.7,5.74,4.8,4.8,0,0,0-1.79,3l0,.17a1.72,1.72,0,0,1-1.7,1.45h-1.68a1.72,1.72,0,0,1-1.7-1.45l0-.17a4.61,4.61,0,0,0-1.74-2.94A7,7,0,0,1,115.1,142.67Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.74,153.31h.81a1.87,1.87,0,0,1,1.87,1.87v0a.59.59,0,0,1-.59.59h-3.37a.59.59,0,0,1-.59-.59v0A1.87,1.87,0,0,1,121.74,153.31Z",
    transform: "translate(244.3 309.1) rotate(180)",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.74,153.31h.81a1.87,1.87,0,0,1,1.87,1.87v0a.59.59,0,0,1-.59.59h-3.37a.59.59,0,0,1-.59-.59v0A1.87,1.87,0,0,1,121.74,153.31Z",
    transform: "translate(244.3 309.1) rotate(180)",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "120.14 148.34 120.87 148.14 119.94 144.72 120.83 145.25 120.92 144.18 122.15 145.09 123.38 144.18 123.47 145.25 124.36 144.72 123.43 148.14 124.16 148.34 125.58 143.11 124.13 143.98 124.02 142.76 122.15 144.15 120.28 142.76 120.18 143.98 118.72 143.11 120.14 148.34",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "120.14 148.34 120.87 148.14 119.94 144.72 120.83 145.25 120.92 144.18 122.15 145.09 123.38 144.18 123.47 145.25 124.36 144.72 123.43 148.14 124.16 148.34 125.58 143.11 124.13 143.98 124.02 142.76 122.15 144.15 120.28 142.76 120.18 143.98 118.72 143.11 120.14 148.34",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 121.72,
    y: 128.17,
    width: 0.87,
    height: 5.92,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.35,
    y: 142.53,
    width: 5.92,
    height: 0.87,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.03,
    y: 142.53,
    width: 5.92,
    height: 0.87,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 113.35,
    y: 131.63,
    width: 0.87,
    height: 5.92,
    transform: "translate(-61.85 119.89) rotate(-45)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 130.09,
    y: 148.37,
    width: 0.87,
    height: 5.92,
    transform: "translate(-68.78 136.63) rotate(-45)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 110.82,
    y: 150.9,
    width: 5.92,
    height: 0.87,
    transform: "translate(-73.68 124.77) rotate(-45)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 127.56,
    y: 134.16,
    width: 5.92,
    height: 0.87,
    transform: "translate(-56.94 131.71) rotate(-45)",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Desk--inject-17"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M197.75,293.71a1,1,0,1,1,0-2h27.88a1,1,0,1,1,0,2Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.75,293.71a1,1,0,1,1,0-2h27.88a1,1,0,1,1,0,2Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.11,291.94l-3.71-26.42a2.09,2.09,0,0,0-2-1.76h-3.55v29.93h7.76A1.48,1.48,0,0,0,200.11,291.94Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.11,291.94l-3.71-26.42a2.09,2.09,0,0,0-2-1.76h-3.55v29.93h7.76A1.48,1.48,0,0,0,200.11,291.94Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.07,293.69H165.53a2.08,2.08,0,0,1-2-1.75l-3.71-26.42a1.49,1.49,0,0,1,1.51-1.76h31.53a2.1,2.1,0,0,1,2,1.76l3.71,26.42A1.49,1.49,0,0,1,197.07,293.69Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.07,293.69H165.53a2.08,2.08,0,0,1-2-1.75l-3.71-26.42a1.49,1.49,0,0,1,1.51-1.76h31.53a2.1,2.1,0,0,1,2,1.76l3.71,26.42A1.49,1.49,0,0,1,197.07,293.69Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.82,280.09a2.31,2.31,0,0,1-2.34,2.72,3.23,3.23,0,0,1-3.09-2.72,2.3,2.3,0,0,1,2.33-2.71A3.24,3.24,0,0,1,181.82,280.09Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "343.14 412.4 340.53 412.4 337.16 300.23 340.62 300.23 343.14 412.4",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "343.14 412.4 340.53 412.4 337.16 300.23 340.62 300.23 343.14 412.4",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "300.99 300.23 300.99 412.4 303.76 412.4 307.01 305.35 340.4 305.35 342.84 412.4 345.58 412.4 345.58 300.23 300.99 300.23",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "300.99 300.23 300.99 412.4 303.76 412.4 307.01 305.35 340.4 305.35 342.84 412.4 345.58 412.4 345.58 300.23 300.99 300.23",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "300.99 412.4 298.38 412.4 297.53 300.23 300.99 300.23 300.99 412.4",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "300.99 412.4 298.38 412.4 297.53 300.23 300.99 300.23 300.99 412.4",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "201.25 412.4 198.63 412.4 195.27 300.23 198.72 300.23 201.25 412.4",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "201.25 412.4 198.63 412.4 195.27 300.23 198.72 300.23 201.25 412.4",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "159.09 300.23 159.09 412.4 161.86 412.4 165.11 305.35 198.5 305.35 200.94 412.4 203.68 412.4 203.68 300.23 159.09 300.23",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "159.09 300.23 159.09 412.4 161.86 412.4 165.11 305.35 198.5 305.35 200.94 412.4 203.68 412.4 203.68 300.23 159.09 300.23",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "159.09 412.4 156.48 412.4 155.64 300.23 159.09 300.23 159.09 412.4",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "159.09 412.4 156.48 412.4 155.64 300.23 159.09 300.23 159.09 412.4",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 151.06,
    y: 293.78,
    width: 147.77,
    height: 6.45,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 151.06,
    y: 293.78,
    width: 147.77,
    height: 6.45,
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 294.81,
    y: 293.78,
    width: 55.34,
    height: 6.45,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 294.81,
    y: 293.78,
    width: 55.34,
    height: 6.45,
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.37,293.94H285.72a2.08,2.08,0,0,1-2-1.75L280,265.86a1.48,1.48,0,0,1,1.5-1.75h36.66a2.08,2.08,0,0,1,2,1.75l3.7,26.33A1.49,1.49,0,0,1,322.37,293.94Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.37,293.94H285.72a2.08,2.08,0,0,1-2-1.75L280,265.86a1.48,1.48,0,0,1,1.5-1.75h36.66a2.08,2.08,0,0,1,2,1.75l3.7,26.33A1.49,1.49,0,0,1,322.37,293.94Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.08,290l-32.57-.15a1.93,1.93,0,0,1-1.85-1.62l-2.89-19.87a1.37,1.37,0,0,1,1.39-1.62l32.57.15a1.92,1.92,0,0,1,1.84,1.62l2.89,19.87A1.37,1.37,0,0,1,320.08,290Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.21,293.82H300.85a1.23,1.23,0,0,1-1.23-1.23h0a1.23,1.23,0,0,1,1.23-1.23h44.36a1.24,1.24,0,0,1,1.24,1.23h0A1.24,1.24,0,0,1,345.21,293.82Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.21,293.82H300.85a1.23,1.23,0,0,1-1.23-1.23h0a1.23,1.23,0,0,1,1.23-1.23h44.36a1.24,1.24,0,0,1,1.24,1.23h0A1.24,1.24,0,0,1,345.21,293.82Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.21,293.82H286.55a1.23,1.23,0,0,1-1.23-1.23h0a1.23,1.23,0,0,1,1.23-1.23h23.66a1.23,1.23,0,0,1,1.24,1.23h0A1.23,1.23,0,0,1,310.21,293.82Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.21,293.82H286.55a1.23,1.23,0,0,1-1.23-1.23h0a1.23,1.23,0,0,1,1.23-1.23h23.66a1.23,1.23,0,0,1,1.24,1.23h0A1.23,1.23,0,0,1,310.21,293.82Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTraining);
export default __webpack_public_path__ + "static/media/training.0eb6a5b558f95ec66c30bf92e8fd6f60.svg";
export { ForwardRef as ReactComponent };